module.exports = __webpack_public_path__ + "static/inter-500.latin-0237402ad72294bee8131737e952cc0a.woff2";